import { useState, useContext, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MuiDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { adminListItems, mainListItems, secondaryListItems } from './listItems';
import { Route, Routes } from 'react-router-dom';
import CarRequestForm from '../carrequest/CarRequestForm';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import CarRequestListingPage from '../carrequest/CarRequestListingPage';
import { ThemeContext } from '../../contexts/ThemeContext';
import Dashboard from '../dashboard/Dashboard';
import { Avatar } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import Logout from '../Logout';
import CarListingPage from '../carrequest/CarListingPage';
import DepartmentListingPage from '../user/DepartmentListingPage';
import UserListingPage from '../user/UserListingPage';
import EmployeeListingPage from '../employee/EmployeeListingPage';
import ExpenseRequestForm from '../expenserequest/ExpenseRequestForm';
import ExpenseRequestListingPage from '../expenserequest/ExpenseRequestListingPage';
import CourierMaterialTypeListingPage from '../courierrequest/CourierMaterialTypeListingPage';
import CourierRequestListingPage from '../courierrequest/CourierRequestListingPage';
import CourierRequestForm from '../courierrequest/CourierRequestForm';
import TravelTicketRequestListingPage from '../travelticket/TravelTicketRequestListingPage';
import TravelTicketRequestForm from '../travelticket/TravelTicketRequestForm';
import HotelBookingListingPage from '../hotelbooking/HotelBookingListingPage';
import HotelBookingRequestForm from '../hotelbooking/HotelBookingRequestForm';
import UniformRequirementListing from '../uniformrequirement/UniformRequirementListing';
import UniformRequirementForm from '../uniformrequirement/UniformRequirementForm';

function Copyright(props) {
  return (
    <Typography sx={{ bottom: 4 }} variant="body2" color="text.primary" align="center" >
      {'Developed by '}
      <Link color="inherit" href="https://aahana.info/">
        AAHANA ELECTROMATION
      </Link>
      {'.'}
    </Typography>
  );
}

const drawerWidth = 280;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    '& .MuiDrawer-paper': {
      position: 'relative',
      whiteSpace: 'nowrap',
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      boxSizing: 'border-box',
      ...(!open && {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
          width: theme.spacing(9),
        },
      }),
    },
  }),
);

// TODO remove, this demo shouldn't need to reset the theme.

function stringToColor(string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

function stringAvatar(name) {
  if (name == null || name == "") return ""

  const initials = name.split(' ')
    .slice(0, 2)
    .map((name) => name[0])
    .join('')

  return {
    sx: {
      ml: 1,
      bgcolor: stringToColor(name),
    },
    children: `${initials}`,
  };
}

export default function Home() {
  const { mode, toggleTheme } = useContext(ThemeContext);
  const [open, setOpen] = useState(false);
  const toggleDrawer = () => {
    setOpen(!open);
  };
  const { user } = useAuth();

  console.log(user)

  const [userName, setUserName] = useState("");
  const [role, setRole] = useState(null);

  useEffect(() => {
    if (user) {
      setUserName(user['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name']);
      setRole(user['http://schemas.microsoft.com/ws/2008/06/identity/claims/role']);
    }
  }, [user]);

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar position="absolute" open={open}>
        <Toolbar
          sx={{
            pr: '24px', // keep right padding when drawer closed
          }}
        >
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={toggleDrawer}
            sx={{
              marginRight: '36px',
              ...(open && { display: 'none' }),
            }}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            component="h1"
            variant="h6"
            color="inherit"
            noWrap
            sx={{ flexGrow: 1 }}
          >
            {document.title}
          </Typography>
          <IconButton color="inherit" onClick={toggleTheme}>
            {mode == 'light' ? <DarkModeIcon /> : <LightModeIcon />}
          </IconButton>
          <Avatar {...stringAvatar(userName)} />
        </Toolbar>
      </AppBar>
      <Drawer variant="permanent" open={open}>
        <Toolbar
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            px: [1],
          }}
        >
          <IconButton onClick={toggleDrawer}>
            <ChevronLeftIcon />
          </IconButton>
        </Toolbar>
        <Divider />
        <List component="nav" sx={{
          maxHeight: 'calc(100vh - 5rem)', 
        }}>
          {mainListItems}
          <Divider sx={{ my: 1 }} />
          {role === 'Admin' &&
            adminListItems
          }
          {secondaryListItems}
        </List>
      </Drawer>
      <Box
        component="main"
        sx={{
          backgroundColor: (theme) =>
            theme.palette.mode === 'light'
              ? theme.palette.grey[100]
              : theme.palette.grey[900],
          flexGrow: 1,
          height: '100vh',
          overflow: 'auto',
        }}
      >
        <Toolbar />
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4, minHeight: 'calc(100vh - 10rem)' }}>
          <Routes>
            <Route path="/logout" element={<Logout />} />
            <Route path="/" element={<Dashboard />} />
            <Route path="/car-request" element={<CarRequestListingPage />} />
            <Route path="/car-request/add" element={<CarRequestForm />} />
            <Route path="/expense-request" element={<ExpenseRequestListingPage />} />
            <Route path="/expense-request/add" element={<ExpenseRequestForm />} />
            <Route path="/courier-request" element={<CourierRequestListingPage />} />
            <Route path="/courier-request/add" element={<CourierRequestForm />} />
            <Route path="/travel-tickets-request" element={<TravelTicketRequestListingPage />} />
            <Route path="/travel-tickets-request/add" element={<TravelTicketRequestForm />} />
            <Route path="/hotel-request" element={<HotelBookingListingPage />} />
            <Route path="/hotel-request/add" element={<HotelBookingRequestForm />} />
            <Route path="/uniform-request" element={<UniformRequirementListing />} />
            <Route path="/uniform-request/add" element={<UniformRequirementForm />} />
            {role === 'Admin' && <Route path='/employee' element={<EmployeeListingPage />} />}
            {role === 'Admin' && <Route path='/user' element={<UserListingPage />} />}
            {role === 'Admin' && <Route path='/car' element={<CarListingPage />} />}
            {role === 'Admin' && <Route path='/department' element={<DepartmentListingPage />} />}
            {role === 'Admin' && <Route path='/courier-material-type' element={<CourierMaterialTypeListingPage />} />}
          </Routes>
        </Container>
        <Copyright />
      </Box>
    </Box>
  );
}
